module.exports = __webpack_public_path__ + "static/media/desk-shadow.30173380.png";